export default __webpack_public_path__ + "84d7b8105c91413a63402845c9e8effc.svg";